import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=19a86a0c&scoped=true"
import script from "./updata.vue?vue&type=script&lang=ts"
export * from "./updata.vue?vue&type=script&lang=ts"
import style0 from "./updata.vue?vue&type=style&index=0&id=19a86a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a86a0c",
  null
  
)

export default component.exports